import type { GameView } from "../render";
import type { Game } from "../Game";

// 输入层：把 canvas 上的原生 pointer 事件翻译成 Game 的拖拽指令。
// 用 DOM pointer 事件 + setPointerCapture，保证手指滑出 canvas 也能收到 move/up，
// 这与原版的交互处理一致、久经验证。
export function attachInput(view: GameView, game: Game): void {
  const canvas = view.canvas;
  canvas.style.touchAction = "none";

  canvas.addEventListener("pointerdown", (e: PointerEvent) => {
    const cell = view.screenToCell(e.clientX, e.clientY);
    if (!cell) return;
    if (game.beginDrag(cell, e.clientX, e.clientY, e.pointerId)) {
      e.preventDefault();
      canvas.setPointerCapture(e.pointerId);
    }
  });

  canvas.addEventListener("pointermove", (e: PointerEvent) => {
    game.moveDrag(e.clientX, e.clientY, e.pointerId);
  });

  const end = (e: PointerEvent) => {
    void game.endDrag(e.clientX, e.clientY, e.pointerId);
    if (canvas.hasPointerCapture(e.pointerId)) canvas.releasePointerCapture(e.pointerId);
  };
  canvas.addEventListener("pointerup", end);
  canvas.addEventListener("pointercancel", end);
}
